import { http, HttpResponse } from 'msw'

import { type RequestableApproverApiModel } from '@webapp/platform/approval-routing/data-access/api-models/RequestableApproverApiModel'
import { RequestableApproverApiModelStub } from '@webapp/platform/approval-routing/data-access/api-models/stubs/RequestableApproverApiModel.stub'
import { getResponseObject } from '@webapp/tests/getResponseObject'

export const mockGetRequestableApproversSuccess = (
  data: RequestableApproverApiModel[] = RequestableApproverApiModelStub.buildList(
    2
  ),
  pagination = {},
  metadata = {}
) => {
  return http.post(
    '/api/v3/approvers/requestable/',
    () => {
      return HttpResponse.json(getResponseObject(data, pagination, metadata), {
        status: 200,
      })
    },
    { once: true }
  )
}

export const mockGetRequestableApproversError = () => {
  return http.post(
    '/api/v3/approvers/requestable/',
    () => {
      return new HttpResponse(null, { status: 401 })
    },
    { once: true }
  )
}
